import * as tslib_1 from "tslib";
import { ChangeDetectorRef, OnChanges, SimpleChanges } from '@angular/core';
import { MenuAccordionComponent } from '../menu-accordion/menu-accordion.component';
import { ContainerBase } from '../../../core/base/container-base';
import { Router } from '@angular/router';
import chaining from '../../../core/helpers/chaining';
import * as _ from 'lodash';
import { Store } from '@ngrx/store';
import * as product from '../../../catalog/actions/product';
var MenuAccordionGroupComponent = /** @class */ (function (_super) {
    tslib_1.__extends(MenuAccordionGroupComponent, _super);
    function MenuAccordionGroupComponent(accordion, _cdr, router, store) {
        var _this = _super.call(this) || this;
        _this.accordion = accordion;
        _this._cdr = _cdr;
        _this.router = router;
        _this.store = store;
        _this._isOpen = false;
        _this.activeChain = [];
        _this.hasChildren = false;
        _this.type = 'default';
        return _this;
    }
    Object.defineProperty(MenuAccordionGroupComponent.prototype, "isOpen", {
        get: function () {
            return this._isOpen;
        },
        set: function (value) {
            if (this.disabled)
                return;
            this._isOpen = value;
            this._cdr.detectChanges();
        },
        enumerable: true,
        configurable: true
    });
    MenuAccordionGroupComponent.prototype.toggle = function () {
        if (this.disabled)
            return;
        this.isOpen = !this.isOpen;
    };
    MenuAccordionGroupComponent.prototype.onToggleClick = function (event) {
        event.stopPropagation();
        this.store.dispatch(new product.SetProductDefaultSortOrder());
        this.toggle();
    };
    MenuAccordionGroupComponent.prototype.navigateTo = function (event) {
        event.preventDefault();
        event.stopPropagation();
        this.router.navigateByUrl("/" + this.link);
    };
    MenuAccordionGroupComponent.prototype.setInactive = function () {
        this.isOpen = false;
    };
    MenuAccordionGroupComponent.prototype.ngOnChanges = function (changes) {
        if (Array.isArray(chaining(changes, 'activeChain.currentValue'))) {
            this.isOpen = _.includes(chaining(changes, 'activeChain.currentValue'), this.id);
        }
    };
    return MenuAccordionGroupComponent;
}(ContainerBase));
export { MenuAccordionGroupComponent };
